import React, { memo } from 'react';
import moment from 'moment';
import cls from 'classnames';
import { useIntl, getLocale } from 'umi';
import { DropdownBox } from 'tea-component';
import TeaConfigProvider from '@/pages/home/components/TeaConfigProvider';
import { getAllCountriesFromRegionCountrySet } from '@/pages/home/utils/utils';
import { getLocalText } from '@/pages/home/utils/lang';
import { getWeekLocaleText } from '@/pages/home/utils/date';
import { IPopoverDateProps } from '@/pages/home/types/holidays';
import { importImg } from '@home/components/RegionSelect/utils';

const PopoverDate: React.FC<IPopoverDateProps> = (props) => {
  const {
    data,
    // 国家数量大于这个值,就分区域展示国家,否则 直接展示国家即可
    size = 10,
  } = props;

  const locale = getLocale();

  const { formatMessage } = useIntl();

  const holidayName = getLocalText(locale, data, 'name', 'name_cn') || '';

  const holidayDesc =
    getLocalText(locale, data, 'description_en', 'description_cn') || '';

  const holidayWeek = getWeekLocaleText(
    formatMessage,
    moment(data?.observed)?.day(),
  );

  const getFlagSrc = (countryCode: string) => countryCode?.toUpperCase() === '#N/A'
    ? importImg(`global`)
    : importImg(`${countryCode?.toLowerCase()}`);

  // 直接渲染国家
  const renderCountries = () => {
    const countries = getAllCountriesFromRegionCountrySet(data?.regions);

    return (
      <div className="popover-home-bottom popover-home-bottom-last">
        {countries?.length > 0 &&
          countries?.map((country) => (
            <span
              key={country?.country_code}
              className="popover-home-textcount"
            >
              <img src={getFlagSrc(country?.country_code)} />
              {getLocalText(
                locale,
                country,
                'country_name_en',
                'country_name_ch',
              )}
            </span>
          ))}
      </div>
    );
  };

  // 分区域渲染国家
  const renderRegionCountrySet = () => {
    if (!data?.regions?.length) return null;

    return data?.regions?.map((region, index) => {
      const countries = region?.country_set || [];

      return (
        <React.Fragment key={region?.area_code}>
          <div className="popover-home-bottom">
            <span className="popover-home-desc">
              {getLocalText(locale, region, 'area_name_en', 'area_name_ch')}
            </span>
          </div>
          <div className={cls({ "popover-home-bottom": true, "popover-home-bottom-last": index === data?.regions?.length - 1 })}>
            {countries?.length > 0 &&
              countries?.map((country) => (
                <span
                  key={country?.country_code}
                  className="popover-home-textcount"
                >
                  <img src={getFlagSrc(country?.country_code)} />
                  {getLocalText(
                    locale,
                    country,
                    'country_name_en',
                    'country_name_ch',
                  )}
                </span>
              ))}
          </div>
        </React.Fragment>
      );
    });
  };

  // 渲染国家地区模块UI
  const renderRegionCountrySetOrCountries = () => {
    if (data?.country_size === 0)
      return <div className="popover-home-bottom">-</div>;
    if (data?.country_size <= size) return renderCountries();
    return renderRegionCountrySet();
  };

  return (
    <TeaConfigProvider>
      <DropdownBox
        className="popover-home"
        onClick={(e) => {
          e?.stopPropagation();
        }}
      >
        <div className="popover-home-title">
          {data?.observed}
          <span className="popover-home-week">{holidayWeek}</span>
        </div>
        <div className="popover-home-name">{holidayName}</div>
        {holidayDesc && <div className="popover-home-text">{holidayDesc}</div>}
        <div className="popover-home-name">
          {formatMessage({ id: 'dbh_country' })}({data?.country_size || 0})
        </div>
        <div className="popover-home-countries">
          {renderRegionCountrySetOrCountries()}
        </div>
      </DropdownBox>
    </TeaConfigProvider>
  );
};

export default memo(PopoverDate);
